import { InclusiveGateway, BpmnModelHelper, FlowNodeState } from "@edp-pmf/bpmn-model";
import { InclusiveGatewayCell } from "@edp-pmf/grapheditor";
import { WfConstants } from "../WfConstants";

/**
 * 排他网关节点，增加状态图片信息
 */
export class WfInclusiveGatewayCell extends InclusiveGatewayCell {
  imgUrls = {
    [FlowNodeState.Default]: WfConstants.IMAGE_PATH + "/InclusiveGateway.png",
    [FlowNodeState.Selected]: WfConstants.IMAGE_PATH + "/InclusiveGateway_select.png",
  };

  createFlowElement(flowElt?: InclusiveGateway) {
    const flowNode = super.createFlowElement(flowElt) as InclusiveGateway;
    flowNode.Id = "InclusiveGateway" + BpmnModelHelper.GenerateElementId();

    return flowNode;
  }
}
